export const sv = {
  common: {
    loading: "Laddar..."
  }
}